import { getCommaSeparatedUIDs } from '@utils/textHelper';
import { itemTypes, programmeTypes, quizSecondaryType } from '@constants/index';
import { getDateInToEpoch } from '@utils/dates';

export const isUserUnauthorised = (data, type) => {
  if (data.isModerator) return false;
  if (type === 'plus-courses' && data.canAddPlusCourse) return false;
  if (
    type === 'special-classes' &&
    (data.canAddPlusCourse || data.canAddSpecialClass)
  )
    return false;
  if (type === 'test-series' && data.canAddPlusCourse) return false;
  if (type === 'template') return false;
  return true;
};

export const modifyStep1CourseData = (data, me, courseUID) => ({
  title: data.title,
  description: data.description,
  for_subscription: true,
  language: data.selectedLanguages[0].id,
  content_languages: getCommaSeparatedUIDs(data.contentSlideLanguages, 'id'),
  goal_uid: data.selectedGoal[0].uid,
  collection_uid: courseUID,
  course_type: data.courseType,
  author_usernames: me.isModerator
    ? getCommaSeparatedUIDs(data.selectedEducators, 'username')
    : me.username
});

export const modifyStep2CourseData = (data, me) => ({
  ...modifyStep1CourseData(data, me),
  topic_uids: getCommaSeparatedUIDs(data.selectedTopics, 'uid'),
  promo_video: data.preview,
  exam_uids: getCommaSeparatedUIDs(data.selectedExams, 'uid'),
  collection_uid: data.courseUID,
  course_type: data.courseType,
  class_preference_uids: getCommaSeparatedUIDs(data.selectedClasses, 'uid')
});

export const modifyStep1TestSeriesCreationData = (data, me) => ({
  programme_type: 2,
  title: data.title,
  description: data.description,
  collection_uid: data.courseUID,
  for_subscription: !data.isFreeTest,
  language: getCommaSeparatedUIDs(data.selectedLanguages, 'id'),
  content_languages: getCommaSeparatedUIDs(data.contentSlideLanguages, 'id'),
  goal_uid: data.selectedGoal[0].uid,
  author_usernames: me.isModerator
    ? getCommaSeparatedUIDs(data.selectedEducators, 'username')
    : me.username
});

export const modifyStep2TestSeriesEditData = (data, me) => ({
  ...modifyStep1TestSeriesCreationData(data, me),
  promo_video: data.preview,
  visible_at: getDateInToEpoch(data.visibleFrom),
  exam_uids: getCommaSeparatedUIDs(data.selectedExams, 'uid'),
  applications_close_at: getDateInToEpoch(data.registrationClosesOn),
  topic_uids: getCommaSeparatedUIDs(data.selectedTopics, 'uid'),
  class_preference_uids: getCommaSeparatedUIDs(data.selectedClasses, 'uid')
});

export const modifystep3CourseData = (data, me, type) => {
  const time = new Date(data.newSession.liveAt).getTime();
  let authorUsername = me.username;
  if (me.isModerator && data.selectedEducators.length > 1)
    authorUsername = data.newSession.selectedEducator.username;
  if (me.isModerator && data.selectedEducators.length === 1)
    authorUsername = data.selectedEducators[0].username;
  let secondaryType = quizSecondaryType.UNDEFINED;
  if (data.programmeType === programmeTypes.TESTSERIES)
    secondaryType = quizSecondaryType.TEST;
  else if (data.programmeType === programmeTypes.COURSE)
    secondaryType = quizSecondaryType.QUIZ;
  return {
    author_username: authorUsername,
    collection_uid: data.courseUID,
    duration: data.newSession.duration,
    live_at: time,
    start_time: time,
    title: data.newSession.title,
    topology_uids: getCommaSeparatedUIDs(
      [
        ...data.newSession.selectedConcepts,
        ...data.newSession.selectedSubConcepts
      ],
      'uid'
    ),
    type: type ? itemTypes.QUIZ : itemTypes.POST,
    quiz_secondary_type: secondaryType
  };
};

export const modifystep3TestSeriesData = (data, me, type) => {
  let authorUsername = me.username;
  if (me.isModerator && data.selectedEducators.length > 1)
    authorUsername = data.newSession.selectedEducator.username;
  if (me.isModerator && data.selectedEducators.length === 1)
    authorUsername = data.selectedEducators[0].username;
  const time = new Date(data.newSession.liveAt).getTime();
  return {
    author_username: authorUsername,
    collection_uid: data.courseUID,
    duration: data.newSession.duration,
    live_at: time,
    start_time: time,
    title: data.newSession.title,
    topology_uids: getCommaSeparatedUIDs(
      data.newSession.selectedConcepts,
      'uid'
    ),
    type: type ? itemTypes.POST : itemTypes.QUIZ
  };
};

export const checkValidURL = (str) => {
  const regex = /(http|https):\/\/(\w+:{0,1}\w*)?(\S+)(:[0-9]+)?(\/|\/([\w#!:.?+=&%!\-/]))?/;
  if (!regex.test(str)) return false;
  return true;
};

export const getCurrentDateTime = (dateString) => {
  let date = new Date();
  if (dateString) date = new Date(dateString);
  const year = date.getFullYear();
  let month = date.getMonth() + 1;
  month = `0${month}`.slice(-2);
  let day = date.getDate();
  day = `0${day}`.slice(-2);
  let hours = date.getHours();
  hours = `0${hours}`.slice(-2);
  let minutes = date.getMinutes();
  minutes = `0${minutes}`.slice(-2);
  return `${year}-${month}-${day}T${hours}:${minutes}`;
};

export const createApiDataForSpecialClass = (key, course, me) => {
  const data = {
    title: course.title,
    goal_uid: course.selectedGoal[0].uid,
    language: course.selectedLanguages[0].id,
    content_languages: getCommaSeparatedUIDs(
      course.contentSlideLanguages,
      'id'
    ),
    author_usernames: me.isModerator
      ? getCommaSeparatedUIDs(course.selectedEducators, 'username')
      : me.username,
    description: course.description,
    duration: course.speciaClassDuration || 60,
    author_username: me.isModerator
      ? course.selectedEducators[0].username
      : me.username,
    live_at: getDateInToEpoch(
      getCurrentDateTime(course.specialClassscheduledDateTime)
    ),
    type: 'post',
    for_subscription: false,
    visible_at: getDateInToEpoch(getCurrentDateTime(course.visibleFrom))
  };
  if (key === 'edit') {
    data.collection_uid = course.courseUID;
    data.item_uid = course.spclClassUID;
    data.exam_uids = getCommaSeparatedUIDs(course.selectedExams);
    data.topic_uids = getCommaSeparatedUIDs(course.selectedTopics);
    data.class_preference_uids = getCommaSeparatedUIDs(course.selectedClasses);
  }
  return data;
};

const findLatestRankInTwoArrays = (array1 = [], array2 = []) => {
  if (!array1.length && !array2.length) return 0;
  if (!array1.length || !array2.length)
    return array1.length
      ? array1[array1.length - 1].rank
      : array2[array2.length - 1].rank;
  const top1Rank = array1[array1.length - 1].rank;
  const top2Rank = array2[array2.length - 1].rank;
  return top1Rank > top2Rank ? top1Rank : top2Rank;
};

export const modifystep2TemplateSessionData = (
  data,
  type,
  isEdit,
  isTemplateCourse = false,
  isContentOperator = false
) => {
  /* Function is working for both addind editing sessions in template
   and template course step 3 before shcedule is called */
  const quizUID =
    data.quizUID ||
    data.newSession.quizUID ||
    data.newSession.template_quiz?.uid ||
    data.newSession.practice_quiz?.uid;
  const educatorSlides =
    data.newSession.educatorSlides ||
    data.newSession.educator_slides ||
    data.newSession.drive_details;
  const learnerNotes =
    data.newSession.learnerNotes || data.newSession.learner_notes;
  const hasPracticeQuiz = !!(
    data.newSession.hasPracticeQuiz ?? data.newSession.practice_quiz?.uid
  );
  const newLessonData = {
    title: data.newSession.title,
    duration: data.newSession.duration,
    type: type ? itemTypes.QUIZ : itemTypes.POST,
    rank: findLatestRankInTwoArrays(data.liveClasses, data.quizzes) + 1,
    educatorSlides,
    learnerNotes,
    hasPracticeQuiz,
    questions: data.newSession.questions,
    quizUID
  };
  if (isEdit) {
    newLessonData.type = data.newSession.type;
    newLessonData.rank = data.newSession.rank;
  }
  if (!type || (type && isContentOperator))
    newLessonData.concepts = data.newSession.selectedConcepts;
  const newTemplateData = { ...data };
  if (isEdit) {
    if (isTemplateCourse) {
      const { liveClasses, quizzes } = data;
      if (!type) liveClasses[data.newSession.index] = newLessonData;
      else quizzes[data.newSession.index] = newLessonData;
      return { liveClasses, quizzes };
    }
    if (!type)
      newTemplateData.liveClasses[data.newSession.index] = newLessonData;
    else newTemplateData.quizzes[data.newSession.index] = newLessonData;
  } else {
    if (isTemplateCourse) {
      const { liveClasses, quizzes } = data;
      if (!type) liveClasses.push(newLessonData);
      else quizzes.push(newLessonData);
      return {
        liveClasses,
        quizzes
      };
    }
    if (!type) newTemplateData.liveClasses.push(newLessonData);
    else newTemplateData.quizzes.push(newLessonData);
  }
  return newTemplateData;
};

export const createTemplateData = (data) => {
  const templateData = {
    title: data.title,
    description: data.description,
    topic_groups: data.selectedTopicGroups,
    topics: data.selectedTopics,
    exams: data.selectedExams,
    class_preference_uids: data.selectedClasses,
    is_content_operator: data.isContentOperator ? 1 : 0,
    session_duration: data.sessionDuration,
    course_type: data.courseType,
    state: data.state === 1 || data.completeTemplate ? 1 : 0,
    goal: {
      goal_name: data.selectedGoal[0].name,
      goal_uid: data.selectedGoal[0].uid
    }
  };
  if (data.uid) templateData.id = data.uid;
  templateData.live_classes = data.liveClasses.map((liveClass) => {
    const session = {
      duration: parseInt(liveClass.duration, 10),
      title: liveClass.title,
      rank: liveClass.rank,
      type: liveClass.type,
      concepts: liveClass.concepts.map((concept) => ({
        name: concept.name,
        uid: concept.uid
      }))
    };
    if (data.isContentOperator) {
      if (
        liveClass.educatorSlides ||
        liveClass.educator_slides ||
        liveClass.drive_details
      )
        session.drive_details =
          liveClass.educatorSlides ||
          liveClass.educator_slides ||
          liveClass.drive_details;
      if (liveClass.learnerNotes || liveClass.learner_notes)
        session.learner_notes =
          liveClass.learnerNotes || liveClass.learner_notes;
      if (liveClass.quizUID || liveClass.practice_quiz)
        session.practice_quiz = {
          uid: liveClass.quizUID || liveClass.practice_quiz?.uid,
          max_question_count:
            liveClass.questions || liveClass.practice_quiz?.max_question_count
        };
    }
    return session;
  });
  templateData.quizzes = data.quizzes.map((quiz) => {
    const newQuiz = {
      duration: parseInt(quiz.duration, 10),
      title: quiz.title,
      rank: quiz.rank,
      type: quiz.type
    };
    if (data.isContentOperator && (quiz.quizUID || quiz.template_quiz?.uid))
      newQuiz.template_quiz = { uid: quiz.quizUID || quiz.template_quiz?.uid };
    if (data.isContentOperator && quiz.concepts)
      newQuiz.concepts = quiz.concepts.map((concept) => ({
        name: concept.name,
        uid: concept.uid
      }));
    return newQuiz;
  });
  return templateData;
};

export const modifyTemplateCourseData = (data, me = {}, isSettingUp = false) =>
  !me.isModerator && isSettingUp
    ? {
        language: data.selectedLanguages[0].id,
        template_id: data.uid,
        classes_schedule: {
          start_at: new Date(
            `${data.schedule.startsFrom}T${data.schedule.time}`
          ).getTime(),
          days: data.schedule.daysOfWeek,
          duration: data.schedule.duration
        }
      }
    : {
        title: data.title,
        description: data.description,
        template_id: data.uid,
        language: data.selectedLanguages[0].id,
        goal_uid: data.selectedGoal[0].uid,
        author_usernames: me.isModerator
          ? getCommaSeparatedUIDs(data.selectedEducators, 'username')
          : me.username,
        content_languages: getCommaSeparatedUIDs(
          data.contentSlideLanguages,
          'id'
        ),
        exam_uids: getCommaSeparatedUIDs(data.selectedExams, 'uid'),
        collection_uid: data.courseUID,
        topic_uids: getCommaSeparatedUIDs(data.selectedTopics, 'uid'),
        promo_video: data.preview,
        course_type: data.courseType || programmeTypes.TESTSERIES,
        class_preference_uids: getCommaSeparatedUIDs(data.selectedClasses)
      };

export const modifyStep3TemplateScheduleData = (data) => ({
  collection_uid: data.courseUID,
  classes_schedule: {
    start_at: new Date(
      `${data.schedule.startsFrom}T${data.schedule.time}`
    ).getTime(),
    days: data.schedule.daysOfWeek,
    duration: data.schedule.duration
  },
  live_classes: data.liveClasses,
  quizzes: data.quizzes
});
